/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

import { KTIcon } from '../../_metronic/helpers'

export default function ExportAllLeadsModal({
  filterChild,
  exporting,
  errorExporting,
  onExport,
  disableExportForReason
}: {
  filterChild: React.ReactNode,
  exporting: boolean,
  errorExporting: string | null,
  onExport: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  disableExportForReason: string
}) {

  return (
    <div className='modal fade' id='modal_export_all_leads' aria-hidden='true'>
      <div className='modal-dialog mw-650px'>
        <div className='modal-content'>
          <div className='modal-header pb-0 border-0 justify-content-end'>
            <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal'>
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>

          <div className='modal-body scroll-y mx-5 mx-xl-18 pt-0 pb-15'>
            <div className='text-center mb-13'>
              <h1 className='mb-3'>
                Export Leads
              </h1>

              <div className='text-muted fw-bold fs-5'>
                Filter leads:
              </div>
            </div>

            {disableExportForReason ? <>

              <div className='alert alert-danger'>
                {disableExportForReason}
              </div>

              <div className='modal-footer'>
                <div className='flex-center'>
                  <button
                    type='button'
                    className='btn btn-primary'
                    data-bs-dismiss='modal'
                    id='export_leads_modal_close'
                  >
                    Close
                  </button>
                </div>
              </div>

            </> : <>

              {filterChild}

              <div className='modal-footer'>
                <div className='flex-center'>
                  <button type='reset' className='btn btn-white me-3' data-bs-dismiss='modal' id='add_partner_modal_cancel'>
                    Cancel
                  </button>
                  <button type='button' className='btn btn-primary' onClick={onExport}>
                    {!exporting && 'Export Leads'}
                    {exporting && (
                      <span className='indicator-progress' style={{ display: 'block' }}>
                        Exporting...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                </div>
                {errorExporting ? <div className='w-100 mt-5'>
                  <div className='alert alert-danger'>
                    {errorExporting}
                  </div>
                </div> : null}
              </div>

            </>}

          </div>

        </div>
      </div>
    </div>
  )
}
